import { action } from 'satcheljs';
import type { SearchScenarioId } from 'owa-search-store';

export interface RESET_SEARCH_STOREActionMessage {
    scenarioId: SearchScenarioId;
}
export const resetSearchStore: (scenarioId: SearchScenarioId) => RESET_SEARCH_STOREActionMessage =
    action(
        'RESET_SEARCH_STORE',
        (scenarioId: SearchScenarioId): RESET_SEARCH_STOREActionMessage => ({
            scenarioId,
        })
    );
